import { memo } from "react";

const KEYFRAMES = `
  @keyframes nc-thinking-pulse {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.25); opacity: 0.6; }
  }
`;

export const ChatTypingIndicator = memo(function ChatTypingIndicator() {
  return (
    <>
      <style>{KEYFRAMES}</style>
      <div
        className="flex h-6 w-full items-center justify-start py-1"
        role="status"
        aria-live="polite"
        aria-label="Assistant is thinking"
      >
        <div
          className="h-4 w-4 shrink-0 rounded-full bg-[var(--color-os-brand)]"
          style={{ animation: "nc-thinking-pulse 1.4s ease-in-out infinite" }}
        />
      </div>
    </>
  );
});
